export default {
  customers: state => state.customers,
  customerInfos: state => state.customerInfos
}
